<script lang="ts" setup>
// Event Handler
</script>
<template>
  <div class="h-full relative">
    <ChatTextModeV2 ref="chatTextModRef" />
  </div>
</template>
